import { useQuery } from '@tanstack/react-query';

import CruiseLineService, { type CruiseLine } from '~/services/cruises/CruiseLineService';

export const cruiseLineKeys = {
  all: ['cruiseLines'] as const,
  list: () => [...cruiseLineKeys.all, 'list'] as const,
  details: () => [...cruiseLineKeys.all, 'detail'] as const,
  detail: (id: string) => [...cruiseLineKeys.details(), id] as const,
};

export function useGetCruiseLines() {
  return useQuery<Array<CruiseLine>>({
    queryKey: cruiseLineKeys.list(),
    queryFn: async () => {
      const response = await CruiseLineService.listWithPagination({ take: 200 });
      return response.result;
    },
  });
}

export function useGetCruiseLine(id: string | undefined, enabled = true) {
  return useQuery<CruiseLine>({
    queryKey: cruiseLineKeys.detail(id ?? ''),
    queryFn: () => CruiseLineService.getCruiseLineById(id),
    enabled: enabled && !!id,
  });
}
